import { UpdateRecInclusionRequest } from "interfaces/Mueller.Business.Models";
import { HTTP_PUT, WebApiRequest } from "tools/webservice";

export const updateRecommendationInclusions = (
  controlNumber: string,
  requestBody: UpdateRecInclusionRequest,
  mountedRef: React.MutableRefObject<boolean>,
  successCallback: () => void,
  errorCallback: () => void,
): void => {
  WebApiRequest({
    method: HTTP_PUT,
    endpoint: `/homeowner/cases/${controlNumber}/recommendations/update-inclusions`,
    payload: requestBody,
    successCallback,
    errorCallback,
    mountedRef,
  });
};
